import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../../module/legacy/forms/mui-input.directive';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
/**
 * Endpoints to submit
 */
const WISHLIST_SHARE_ENDPOINT = 'wishlist/share';
/**
 * Form data
 */
interface IWishlistShareFormData {
    sender_name?: string;
    recipient_name?: string;
    recipient_email?: string;
    message?: string;
}
@Component({
    selector: 'wishlist-share-form',
    templateUrl: 'wishlist-share-form.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [InputWrapComponent, TranslationModule, MuiInputDirective, FormsModule, ResultComponent, ActionComponent, InputWrapBodyDirective]
})
export class WishlistShareFormComponent extends AbstractFormComponent<IWishlistShareFormData> implements OnInit {
    protected submitPath = WISHLIST_SHARE_ENDPOINT;
}
